<template>
  <div>
    <h1>Search</h1>
    <ul>
      <li v-for="[key, value] in params" :key="key">{{ key }}: {{ value }}</li>
    </ul>
  </div>
</template>

<script>
export default {
  name: "SearchPage",
  toolbar: {
    title: "Vyhledávání"
  },
  data() {
    return {};
  },
  computed: {
    params() {
      return Object.entries(this.$route.query);
    }
  }
};
</script>

<style scoped></style>
